import { useContext, useEffect, useMemo, useState } from "react";
import styles from "./DocflixLoader.module.scss";
import logo from "../../assets/lotties/DocFlix_logo.json";
import logoMobile from "../../assets/lotties/DocFlix_logo_mobile.json";
// import logoVideo from "../../assets/video/DocFlix_logo.webm";
// import logoVideoMobile from "../../assets/video/DocFlix_logo_mobile.webm";

// import Lottie from "react-lottie-player";
import Lottie from "lottie-react";
import { isMobileDevice } from "../../utils/getPlatformInfo";
// import ReactPlayer from "react-player";
import { ConstantDataContext } from "../../contexts/ConstantContext/ConstantDataContextProvider";

const segmentData = {
  handleBtn: [
    {
      start: 0,
      end: 95,
    },
    {
      start: 96,
      end: 149,
    },
  ],
};

const DocflixLoader = ({ type = "lottie" }) => {
  const { remoteConfigData } = useContext(ConstantDataContext);
  const [segmentFrom, setSegmentFrom] = useState(
    segmentData.handleBtn[0].start
  );

  const [segmentTo, setSegmentTo] = useState(segmentData.handleBtn[0].end);
  const [segmentsEnabled, setSegmentsEnabled] = useState(true);
  const [play, setPlay] = useState(true);
  const [loop, setLoop] = useState(false);
  const [speed, setSpeed] = useState(1);
  const [goTo, setGoTo] = useState(0);
  const [direction, setDirection] = useState(1);

  const [loading, setLoading] = useState(true);

  const segments = [segmentFrom, segmentTo];

  useEffect(() => {
    if (loading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [loading]);

  const handleLoad = (e) => {
    // console.log("load", e);
  };
  const handleSegmentStart = (e) => {
    // console.log("handleSegmentStart", e);
  };
  const handleLoopComplete = (e) => {
    if (e.currentLoop === 1) {
      setLoop(false);
    }
    setSegmentFrom(segmentData.handleBtn[1].start);
    setSegmentTo(segmentData.handleBtn[1].end);
    // console.log("loopComplete", e);
  };
  const handleEnterFrame = (e) => {};

  const handleComplete = (e) => {
    sessionStorage.setItem("showLoader", true);
    setLoading(false);
  };

  const handleVideoEnd = async (e) => {
    setLoading(false);
  };

  const activeSeason = remoteConfigData["festivalData"]["activeSeason"];

  const lottieToRender = useMemo(() => {
    try {
      let _data =
        remoteConfigData[
          remoteConfigData["festivalData"][activeSeason][
            !isMobileDevice ? "splashDesktop" : "splashMobile"
          ]
        ];

      if (remoteConfigData.showFestivalAnimation && activeSeason && _data) {
        return _data;
      } else {
        return !isMobileDevice ? logo : logoMobile;
      }
    } catch (error) {
      return !isMobileDevice ? logo : logoMobile;
    }
  }, [isMobileDevice, remoteConfigData]);

  return type === "lottie" ? (
    <Lottie
      className={`mainLoader ${loading ? styles.container : "d-none"}`}
      loop={loop}
      play={play}
      onComplete={handleComplete}
      onLoopComplete={handleLoopComplete}
      onEnterFrame={handleEnterFrame}
      onSegmentStart={() => handleSegmentStart("segmentStart")}
      onLoad={handleLoad}
      animationData={lottieToRender}
    />
  ) : // <Lottie
  //   className={loading ? styles.container : "d-none"}
  //   loop={loop}
  //   play={play}
  //   speed={speed}
  //   goTo={goTo}
  //   direction={direction}
  //   segments={segmentsEnabled && segments}
  //   animationData={lottieToRender}
  //   onComplete={handleComplete}
  //   onLoopComplete={handleLoopComplete}
  //   onEnterFrame={handleEnterFrame}
  //   onSegmentStart={() => handleSegmentStart("segmentStart")}
  //   onLoad={handleLoad}
  // />
  // ) : type === "video" ? (
  //   <div className={loading ? styles.container : "d-none"}>
  //     <ReactPlayer
  //       playing={loading}
  //       url={!isMobileDevice ? logoVideo : logoVideoMobile}
  //       playsinline={true}
  //       muted
  //       autoPlay
  //       onEnded={handleVideoEnd}
  //       height={"100%"}
  //       width={"100%"}
  //       controls={false}
  //     />
  //   </div>
  null;
};

export default DocflixLoader;
